import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { ConsumerSearchPage as Page } from './ConsumerSearchPage'
import { AppStateType } from '../../reducers'
import { selectPublishedSearch } from '../../selectors/publishedSearch'
import { selectGroupsList } from '../../selectors/groups'

const mapStateToProps = (state: AppStateType) => ({
  groupsList: selectGroupsList(state),
  groupsLoading: state.groups.isLoading,
  groupsLoaded: state.groups.isLoaded,
  search: selectPublishedSearch(state),
})

export const ConsumerSearchPage = withRouter(
  connect(mapStateToProps)(Page)
) as React.FC<{}>
